import { NotificationDeliveryTarget } from 'constants/notice';
import { PaginationSetting } from 'constants/paginationSetting';
import { useEffect, useState } from 'react';
import { useGetNotificationListQuery } from 'views/utils/graphql/graphql';

export type NotificationListPageProps = {
  deliveryTarget: NotificationDeliveryTarget;
};

export const useNotificationListPage = (props: NotificationListPageProps) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [notificationList, _] = useGetNotificationListQuery({
    variables: {
      deliveryTarget: props.deliveryTarget,
      count: PaginationSetting.pageCount,
      page: currentPage,
    },
    // 詳細と一覧の遷移を繰り返す際に毎回ローディングが出るのは邪魔なのでcache-and-network
    requestPolicy: 'cache-and-network',
  });

  return {
    notificationList,
    currentPage,
    setCurrentPage,
    perPageCount: PaginationSetting.pageCount,
  };
};
